/** Host homologa.* ou flag de build — faixa visual de ambiente. */
export function isHomologHost(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname.toLowerCase()
  return host === 'homologa.basepolitica.com.br' || host.startsWith('homologa.')
}
